import request from '@/util/request'

// 金融服务列表
export function financingMsgList (data) {
  return request({
    method: "post",
    url: '/api/financingMsgList',
    params: data
  })
}